export default __webpack_public_path__ + "static/media/HistoricTextComment.2fe1cc54.svg";